import Component from '../core/Component'
import enquire from 'enquire.js'
import { queries } from '../core/config'
import EventBus from '../core/EventBus'
import support from '../utils/BrowserSupport'

const STATES = {
    ACTIVE: 'is-active'
}

export default class NavLine extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            line: null
        }

        this.state = {
            active: false,
            translate: 0,
            scale: 0
        }
    }

    prepare() {
        EventBus.on('swup:aftercontentchange', this.handleSwupChange)
        this.ref.line.addEventListener(support.transitionEnd, this.handleTransitionEnd)
        this.update()
    }

    destroy() {
        EventBus.off('swup:aftercontentchange', this.handleSwupChange)
    }

    handleSwupChange = () => {
        this.update()
    }

    handleTransitionEnd = event => {
        if (event.target === this.ref.line && !this.state.active) {
            this.ref.line.classList.remove(STATES.ACTIVE)
        }
    }

    update() {
        const target = this.element.querySelector('.Nav-link.is-active')

        if (target) {
            const box = target.getBoundingClientRect()
            const elementBox = this.element.getBoundingClientRect()

this.state.translate = box.left - elementBox.left + box.width/2

            if (!this.state.active) {
                this.state.scale = 0
                this.render()

                this.ref.line.offsetWidth
                this.ref.line.classList.add(STATES.ACTIVE)
                this.state.active = true
            }

            if (this.state.active) {
                this.state.scale = box.width
                this.render()
            }
        }

        if (!target) {
            if (this.state.active) {
                this.state.scale = 0
                this.state.active = false
                this.render()
            }
        }
    }

    render() {
        this.ref.line.style.transform = `translateX(${this.state.translate}px) skew(-45deg) scaleX(${this.state.scale})`
    }
}
